/**
 * Available HeroBanner actions placement options.
 *
 * Defines where the actions slot is rendered within the hero banner header area.
 * @public
 * @since 2.23.0
 */
enum HeroBannerActionsPlacement {
	/**
	 * Places the actions to the right of the header text, aligned to the top of the header row.
	 * @public
	 */
	TopEnd = "TopEnd",

	/**
	 * Places the actions below the header text, aligned to the start.
	 * @public
	 */
	BottomStart = "BottomStart"
}

export default HeroBannerActionsPlacement;
